import Vue from "vue";
import Vuetify from "vuetify/lib";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#D2D2D2",   
        secondary: "#31635f",
        accent: "#81C784",
      },
    },
  },
});